import { chrome } from "./chrome";
import type { HeroSpiel } from "./types";

export const hero: HeroSpiel = {
  tagLine:
    "In a sea of bloated battleships, we're the unit you deploy on a speedboat.",
  support:
    "Seriously though — we're a lean product team built by engineers. We design, build and operate complex systems that scale, iterate and ship fast. We get things done. No bureaucratic slowdowns.",
  ctaPrimary: chrome.ctaPrimary,
  ctaSecondary: chrome.ctaSecondary,
};
